// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import type { CycleTimeReportFilter } from '@/report/api/types';
import { inboundShipmentCycleTimeReportSchema } from '@/shipment/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';
import queryString from 'query-string';
import { z } from 'zod';

const inboundShipmentCycleTimeReportResponseSchema = z.object({
  data: inboundShipmentCycleTimeReportSchema,
  metadata: responseMetadataSchema,
});

type InboundShipmentCycleTimeReportResponse = z.infer<
  typeof inboundShipmentCycleTimeReportResponseSchema
>;

export function serializeInboundShipmentCycleTimeReportFilter(
  filter?: CycleTimeReportFilter
): string {
  if (!filter) {
    return '';
  }

  return queryString.stringify({
    startDate: serializeDateForAPI(filter.interval.start),
    endDate: serializeDateForAPI(filter.interval.end),
  });
}

export async function getInboundShipmentCycleTimeReport(
  filter?: CycleTimeReportFilter
): Promise<InboundShipmentCycleTimeReportResponse> {
  const url = '/v1/report/shipment/inbound/cycle-time';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: {
      startDate: serializeDateForAPI(filter?.interval.start),
      endDate: serializeDateForAPI(filter?.interval.end),
    },
  });

  return parseResponse(
    inboundShipmentCycleTimeReportResponseSchema,
    response.data,
    {
      schemaName: 'InboundShipmentCycleTimeReport',
      endpoint: url,
    }
  );
}
